module.exports = __webpack_public_path__ + "media/entities/1130-c74fb04a.png";